import React, { FC, PropsWithChildren, useEffect } from 'react';
import { configuration } from 'config/constants';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from 'components/common/ErrorBoundary';
import { Header } from './Header';
import { Footer } from './Footer';
import { HelpCenter } from './HelpCenter';
import { SplashScreen } from './SplashScreen';
import { SgwtConnect } from './SgwtConnect';
import { AppContext } from 'services/ApiService/Subscription/SubscriptionApiClient';
import { useGetAppContextSubscription } from 'queries/AppContextSubscription/appContextSubscription.queries';
import { LoadingPage } from 'components/common/Loading';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
    const { data, isFetching } = useGetAppContextSubscription();

    const checkUserPermission = (appContext: AppContext) => {
        const permissions = appContext?.loggedUser?.permissions?.map(x => x) || [];
        if (appContext?.loggedUser === null
            || !permissions.includes(configuration.requiredPermission)) {
            window.location.replace(configuration.externalLinks.requestAccessUrl);
            return false;
        }
    };

    useEffect(() => {
        if (data) {
            checkUserPermission(data);
        }
    }, [data?.loggedUser?.permissions?.join(',')]);

    if (isFetching || !data) {
        return <LoadingPage />;
    }

    return <div>
        <Header />
        <main className="py-4 bg-lvl1" style={{ minHeight: 'calc(100vh - var(--header-height))' }}>
            <ErrorBoundary>{children}</ErrorBoundary>
        </main>
        <Footer />
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            closeButton={false}
            icon={false}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            stacked
        />
        <HelpCenter />
        <SgwtConnect />
        <SplashScreen />
    </div>;
};
